module.exports = __webpack_public_path__ + "static/media/icon_receipt01.ad96813f.png";